export function BallFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M14.293 4.334a8.016 8.016 0 014.314 3.154c-.04.085-.07.178-.086.279l-.315 1.988a1 1 0 00.534 1.048l1.24.631a7.967 7.967 0 01-.821 4.14 1.007 1.007 0 00-.232.047l-2.472.803a1 1 0 00-.691.951v1.686A7.964 7.964 0 0112 20c-1.36 0-2.642-.34-3.764-.939v-1.686a1 1 0 00-.69-.95l-2.473-.804a1.006 1.006 0 00-.232-.046 7.967 7.967 0 01-.83-3.987l-.001.011 1.564-.796a1 1 0 00.533-1.048l-.36-2.274a.985.985 0 00-.112-.328 8.012 8.012 0 014.078-2.821c.025.022.052.044.08.065l1.62 1.176a1 1 0 001.175 0l1.706-1.24zM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm-3.216 8.337l2.628-1.91a1 1 0 011.176 0l2.628 1.91a1 1 0 01.364 1.118l-1.004 3.09a1 1 0 01-.951.691h-3.25a1 1 0 01-.95-.69L8.42 11.454a1 1 0 01.364-1.118z"
      ></path>
    </svg>
  );
}
